import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../src/environments/env';
import { SppdashboardService } from '../dashboard/sppdashboard.service';

@Component({
  selector: 'app-vss',
  templateUrl: './vss.component.html',
  standalone: false,
  styleUrl: './vss.component.scss'
})
export class VssComponent {

  constructor(private router:Router,private sppdashboardService: SppdashboardService,){}
  //public access: boolean = true;

  ngOnInit(){

//     this.sppdashboardService.getUser().subscribe((response: any) => {
//       if (response.success === true) {
       

//         //this.date = new Date('2024-06-19T09:30:15.488466Z');

//       //   this.sppdashboardService.getPayment(response.data.email).subscribe((res: any) => {
//       // if(!res.data.orderNumber){
//       if(response.data.status==='ACTIVE')

//         this.access = true;
//       }
//       else{
//         this.access = false;
//       }

  
  
// })

  window.open("https://my.visualstudio.com/", '_blank')
    this.router.navigate(['/home']);
  }

}
